<template>
	<module-field :bind="$props">
		<div class="input-box">
			<selectize v-model="inputVal">
				<option value="">Select {{ field.name }}</option>
				<option v-for="option in dropdownOptions" :key="`field-${ field.id }-${ option }`" :value="option">{{ option }}</option>
			</selectize>
		</div>
	</module-field>
</template>

<script>
// import CrudField from '@/mixins/CrudField';
import CrudField from '@/mixins/CrudField';

export default {

	mixins: [ CrudField ],

	data() {
		return {
			settings: {
				valueField: 'id',
				labelField: 'name',
				searchField: [ 'name' ],
				persist: false,
				create: false
			}
		};
	},

	computed: {
		dropdownOptions: function() {
			return this.field.specific_data.split(',').map(option => option.trim());
		}
	},
};
</script>
